<template>
  <div>
    <b-modal
      ref="catalog-progress-modal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      size="sm"
    >
      <div class="d-flex align-items-center mb-3">
        <!-- <font-awesome-icon class="mt-3" :icon="['fas', 'redo']" /> -->
        <img
          v-if="!$loading && !state.products.is_sync_error"
          src="../assets/images/success.svg"
          alt
        />
        <img
          v-if="!$loading && state.products.is_sync_error"
          src="../assets/images/alert.svg"
          alt
        />
        <img v-if="$loading" src="../assets/images/downloading.svg" alt />
        <h5 class="updt-cat ml-2" v-if="$loading">Updating Catalog</h5>
        <h5
          class="updt-cat ml-2"
          v-if="!$loading"
          v-text="
            !$loading && !state.products.is_sync_error
              ? 'Catalog Updated'
              : 'Catalog Update Failed'
          "
        ></h5>
      </div>
      <!-- <h5 class="updt-cat">{{$loading==true?'Updating Catalog':'Catalog Updated'}}</h5> -->
      <div v-if="$loading" class="mb-1">
        <p class="dark-p">
          Please wait while we update your product catalog to ensure a seamless
          retail experience.
        </p>
        <!-- <b-progress :value="100" :max="100" animated></b-progress> -->
        <b-progress
          :value="totalProgress"
          :show-progress="totalProgress != 100"
          :precision="1"
          :max="max"
          animated
          class="catalog"
        ></b-progress>
      </div>
      <div v-if="!$loading && !state.products.is_sync_error">
        <p class="dark-p">
          Your catalog is up-to-date.
          <br />Happy retailing!
        </p>
        <div class="row">
          <div class="col-md-9 d-flex align-items-center">
            <b-link class="key-link" @click="openKeyboardModal">
              <font-awesome-icon :icon="['fa', 'keyboard']" />&nbsp;Keyboard
              shortcuts
            </b-link>
          </div>
          <div class="col-md-3">
            <b-button
              class="float-right"
              variant="primary"
              @click="hideCatalogProgress"
              v-if="!$loading && !state.products.is_sync_error"
              v-shortkey="['enter']"
              @shortkey="hideCatalogProgress"
              id="done-progress"
              >Done</b-button
            >
          </div>
        </div>
      </div>
      <div v-if="!$loading && state.products.is_sync_error">
        <p class="dark-p">
          There was an error updating your catalog.
          <br />Please retry or try again later!
        </p>
        <div class="d-flex mt-4">
          <b-button
            class="mr-1"
            block
            variant="danger"
            @click="hideCatalogProgress('close')"
            v-if="!$loading"
            v-shortkey="['enter']"
            @shortkey="hideCatalogProgress('close')"
            id="close-progress"
            >Close</b-button
          >
          <b-button
            variant="primary"
            class="ml-1"
            @click="retrySync"
            block
            v-if="!$loading"
            id="retry-progress"
            >Retry</b-button
          >
        </div>
      </div>
    </b-modal>
    <keyboard-shortcut-modal
      :openShortcuts="openShortcuts"
      @hide="hideKeyboardModal"
    ></keyboard-shortcut-modal>
  </div>
</template>

<script>
import KeyboardShortcutModal from "./KeyboardShortcutModal";
import { mapState } from "vuex";

export default {
  name: "catalog-progress-modal",
  components: {
    KeyboardShortcutModal,
  },
  props: {
    catalogProg: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    totalProgress() {
      if (this.state.products.progress.max != 0) {
        return (
          (this.state.products.progress.current /
            this.state.products.progress.max) *
          100
        );
      } else {
        return 100;
      }
    },
  },
  watch: {
    catalogProg() {
      if (this.catalogProg == true) {
        this.$refs["catalog-progress-modal"].show();
      } else if (this.catalogProg == false) {
        this.hideCatalogProgress();
      }
    },
  },
  data() {
    return {
      max: 100,
      openShortcuts: false,
    };
  },
  methods: {
    hideCatalogProgress(src) {
      this.$refs["catalog-progress-modal"].hide();
      this.$emit("updateHide");
      if (src == "close") this.$store.commit("products/sync_error", false);
    },
    openKeyboardModal() {
      this.hideCatalogProgress();
      this.openShortcuts = true;
    },
    hideKeyboardModal() {
      this.openShortcuts = false;
    },
    retrySync() {
      this.$loading = true;
      this.state.sessions.syncLoading = true;
      this.$store.commit("products/sync_error", false);
      this.$store
        .dispatch("offline/saveOfflineStoreProducts")
        .then(() => {
          this.$loading = false;
          this.state.sessions.syncLoading = false;
        })
        .catch(() => {
          this.$loading = false;
          this.state.sessions.syncLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.updt-cat {
  font-size: 15px;
  font-weight: normal;
  margin: 0;
  /* padding: 12px 0px 12px 0px; */
}
.theme-dark {
  .updt-cat {
    color: $white-color;
  }
  .dark-p {
    color: #808080 !important;
  }
}
</style>
